const draggable = "_35sd1fcm952";

export { draggable };
import "./input.draggable.style.linaria.module.css";
//# sourceMappingURL=input.draggable.style.js.map
